import { SET, UPDATE } from '../actions/device';

const initialState = {
    userAgent: null,
    currentDevice: 'desktop',
};

export default function device(state = initialState, action) {
    switch (action.type) {
    case SET:
        return Object.assign({}, state, {
            userAgent: action.payload.userAgent,
            currentDevice: action.payload.currentDevice,
        });
    case UPDATE:
        return Object.assign({}, state, {
            currentDevice: action.payload.currentDevice,
            windowWidth: action.payload.width,
        });
    default:
        return state;
    }
}



/** WEBPACK FOOTER **
 ** /src/shared/redux/device.js
 **/